import type { ChatMessage, ChatMessageGroup } from "../chat.types";

export const groupMessages = (msgs: ChatMessage[], currentUser: string): ChatMessageGroup[] => {
  if (msgs.length === 0) return [];

  const result: ChatMessageGroup[] = [];
  let current: ChatMessageGroup | null = null;

  for (const msg of msgs) {
    // Same minute: compare up to "YYYY-MM-DDTHH:MM" (16 chars)
    const msgMinute = msg.sentAt.slice(0, 16);
    const curMinute = current?.sentAt.slice(0, 16);

    if (current && current.from === msg.from && curMinute === msgMinute) {
      current.messages.push(msg);
      current.status = msg.status;
      current.streaming = !!msg.streaming;
    } else {
      current = {
        id: msg.id,
        from: msg.from,
        sentAt: msg.sentAt,
        side: msg.from === currentUser ? "right" : "left",
        status: msg.status,
        streaming: !!msg.streaming,
        messages: [msg],
      };
      result.push(current);
    }
  }

  return result;
};
